import React from "react";
import { useSbLayout } from "../../context/LayoutContext";


export default function MainContent({
  title = "Dashboard Overview",
  subtitle = "Welcome back! Here's what's happening today.",
  headerRight,
  children,
}) {
  const { collapsed } = useSbLayout();

  return (
    <main className={`sb-main-content ${collapsed ? "sb-sidebar-collapsed" : ""}`}>
      {children}
    </main>
  );
}
